var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3241 8.80088L13.0196 6.10538C13.059 6.06594 13.1091 6.03908 13.1637 6.02818C13.2184 6.01729 13.275 6.02286 13.3264 6.04419C13.3779 6.06552 13.4219 6.10164 13.4528 6.14799C13.4837 6.19433 13.5001 6.24881 13.5 6.3045V11.6955C13.5 11.9464 13.1962 12.0724 13.0196 11.8946L10.3241 9.19913C10.2979 9.173 10.2772 9.14197 10.263 9.1078C10.2488 9.07363 10.2415 9.037 10.2415 9C10.2415 8.96301 10.2488 8.92638 10.263 8.89221C10.2772 8.85804 10.2979 8.827 10.3241 8.80088Z",
    fill: "#373473"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0312 0C16.5534 0 17.0542 0.207421 17.4234 0.576634C17.7926 0.945846 18 1.44661 18 1.96875V16.0312C18 17.118 17.118 18 16.0312 18H1.96875C1.44661 18 0.945845 17.7926 0.576633 17.4234C0.20742 17.0542 0 16.5534 0 16.0312V1.96875C0 1.44661 0.20742 0.945846 0.576633 0.576634C0.945845 0.207421 1.44661 0 1.96875 0H16.0312ZM16.3125 1.96875C16.3125 1.89416 16.2829 1.82262 16.2301 1.76988C16.1774 1.71713 16.1058 1.6875 16.0312 1.6875H7.3125V16.3125H16.0312C16.1058 16.3125 16.1774 16.2829 16.2301 16.2301C16.2829 16.1774 16.3125 16.1058 16.3125 16.0312V1.96875ZM5.625 16.3125V1.6875H1.96875C1.89416 1.6875 1.82262 1.71713 1.76988 1.76988C1.71713 1.82262 1.6875 1.89416 1.6875 1.96875V16.0312C1.6875 16.1058 1.71713 16.1774 1.76988 16.2301C1.82262 16.2829 1.89416 16.3125 1.96875 16.3125H5.625Z",
    fill: "#373473"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(-1 0 0 1 18 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSidebar);
export default __webpack_public_path__ + "static/media/close_sidebar.10af06f6ff01b92b8296d2d469bd14a7.svg";
export { ForwardRef as ReactComponent };